import { c as _c } from "react/compiler-runtime";
import { ApiKey } from '../../../../../../typings/ApiKey.interface';
import { formatDate, getTimezoneAbbreviation } from '../../../utils/date';
import { useDatePreferences } from '../../hooks/useDatePreferences';
import Badge from '../base/Badge';
import Icon from '../base/Icon';
import Text from '../base/Text';
import Tooltip from '../base/Tooltip';
import { Div } from '../helpers/StyledUtils';
import { describeApiKeyScopes } from './ApiKeyScopesFields';
interface ApiKeyPermissionsBadgeProps {
  api_key: ApiKey;
}
export function ApiKeyPermissionsBadge(t0) {
  const $ = _c(4);
  const {
    api_key
  } = t0;
  let t1;
  if ($[0] !== api_key) {
    t1 = describeApiKeyScopes(api_key);
    $[0] = api_key;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== t1) {
    t2 = <Badge neutral={true} subtle={true}>{t1}</Badge>;
    $[2] = t1;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  return t2;
}
interface ApiKeyLabelCellProps {
  api_key: ApiKey;
  ellipsis?: boolean;
  /** Hide the inline permissions badge — for tables that render it in its own column. */
  hide_permissions?: boolean;
}
export function ApiKeyLabelCell(t0) {
  const $ = _c(20);
  const {
    api_key,
    ellipsis,
    hide_permissions
  } = t0;
  const {
    timezone
  } = useDatePreferences();
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      y: 3
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      align: "center",
      gap: 2
    };
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const t3 = api_key.label ?? "Untitled";
  let t4;
  if ($[2] !== ellipsis || $[3] !== t3) {
    t4 = <Text semi={true} size="s" ellipsis={ellipsis}>{t3}</Text>;
    $[2] = ellipsis;
    $[3] = t3;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== api_key.expires_at || $[6] !== timezone) {
    t5 = api_key.expires_at ? <Div flex={{
      align: "center",
      gap: 1
    }}><Tooltip tooltip={`Expires ${formatDate(api_key.expires_at, "MMM d, yyyy, h:mm a", timezone)} 
          ${getTimezoneAbbreviation(timezone, api_key.expires_at)}`}><Icon icon="change" small={true} danger={true} pointer={true} /></Tooltip></Div> : null;
    $[5] = api_key.expires_at;
    $[6] = timezone;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== api_key || $[9] !== hide_permissions) {
    t6 = !hide_permissions && <ApiKeyPermissionsBadge api_key={api_key} />;
    $[8] = api_key;
    $[9] = hide_permissions;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== t4 || $[12] !== t5 || $[13] !== t6) {
    t7 = <Div flex={t2} min_w={0}>{t4}{t5}{t6}</Div>;
    $[11] = t4;
    $[12] = t5;
    $[13] = t6;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[15] !== api_key.expires_at) {
    t8 = api_key.expires_at && <Text danger={true} size="xs" />;
    $[15] = api_key.expires_at;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  let t9;
  if ($[17] !== t7 || $[18] !== t8) {
    t9 = <Div p={t1}>{t7}{t8}</Div>;
    $[17] = t7;
    $[18] = t8;
    $[19] = t9;
  } else {
    t9 = $[19];
  }
  return t9;
}